import PaginaInicial from '@/router/routes/paginaInicial'
import Estoque from '@/router/routes/estoque'
import Manual from '@/router/routes/manual'
import Parametros from '@/router/routes/parametros'
import EtiquetaProduto from '@/router/routes/etiquetaProduto'
import EtiquetaListagem from '@/router/routes/etiquetaListagem'
import NaoEncontrado from '@/views/NaoEncontrado'


export default [
    {
        path: "/",
        component: () => import('@/layouts/default'),
        meta:{
            auth: true
        },
        children: [
            PaginaInicial,
            Estoque,
            Manual,
            EtiquetaProduto,
            EtiquetaListagem,
            Parametros
        ]
    },
    {
        id: 'login',
        path: '/login',
        isHeader: false,
        hidden: true,
        icone:'keys',
        name: 'login',
        component: () => import( '@/views/login/login.vue'),
        meta: {
          auth: false,
          titulo: 'Login',
          descricao: 'Pagina para login.',
          possuiNivel: () => true
        }
    },
    {
        id:'catchAll',
        isHeader: false,
        hidden: true,
        icone: 'cancel',
        path: "/:catchAll(.*)",
        name: "NaoEncontrado",
        component: NaoEncontrado,
        meta: {
          titulo:'404'
        }
      },
]